import operateContent from './operateContent';
import type EditorViewState from '../store/schema/EditorViewState';
import type { CompositeEditorViewState } from '../store/schema/CompositeEditorViewState';

export default function focusToEditor(viewState: EditorViewState) {
    operateContent(
        viewState as CompositeEditorViewState,
        (editor, range) => {
            if (!range) {
                editor.focus();
                range = editor.getSelectionRange();
            }
            return range;
        },
        (value, selectionStart, selectionEnd) => ({
            value,
            selectionStart,
            selectionEnd,
            focus: true,
        })
    );
}
